module.exports = __webpack_public_path__ + "media/src/images/icons/rules/blue-0ba5fb87ed41e9348194075eb2c96ead.svg";